@if (loading()) {
	<tui-loader size="xs" />
} @else if (path(); as path) {
	<ng-content />

	@if (showHome()) {
		@if (archived()) {
			<ng-container
				*ngTemplateOutlet="
					anchorContent;
					context: { segment: archivedPath, last: !path.length }
				"
			/>
		} @else {
			<ng-container
				*ngTemplateOutlet="
					anchorContent;
					context: { segment: homePath, last: !path.length }
				"
			/>
		}
	}

	@for (segment of path; track segment.id) {
		<ng-container
			*ngTemplateOutlet="anchorContent; context: { segment, last: $last }"
		/>
	}

	<ng-content select="end" />
}

<ng-template #anchorContent let-segment="segment" let-last="last">
	@if (linkFor(); as linkFor) {
		<a
			tuiLink
			size="s"
			appearance="ghost"
			[attr.disabled]="disabled()"
			[routerLink]="!disabled() ? linkFor(segment) : undefined"
			[tuiHint]="segment.name"
			tuiHintAppearance="dark"
		>
			{{ segment.name }}
		</a>
	} @else {
		<a
			tuiLink
			size="s"
			appearance="ghost"
			[attr.disabled]="disabled()"
			[routerLink]="
				!disabled()
					? (segment | contentUrl: { asArchived: archived() })
					: undefined
			"
			[tuiHint]="segment.name"
			tuiHintAppearance="dark"
		>
			{{ segment.name }}
		</a>
	}

	@if (!last) {
		<tui-icon icon="@tui.chevron-right" />
	}
</ng-template>
